module.exports = __webpack_public_path__ + "static/media/button-back.52fe9041.png";